import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { VOUCHERS_SLICE } from "./sliceNames";
import { VOUCHERS_INITIAL_VALUE } from "constants/initialValue";
import { IPromotion } from "interfaces/Promotions/promotions.interface";

interface IUpdateVoucherReducerState {
  promotions?: IPromotion[];
  vouchersLoading?: boolean;
  crpVouchers?: any[];
  skuAndTocVouchers?: any[];
  skuVouchers?: any[];
  allVouchers?: any[];
}

const vouchersSlice = createSlice({
  name: VOUCHERS_SLICE,
  initialState: VOUCHERS_INITIAL_VALUE,
  reducers: {
    updateVouchersReducerState: (state, action: PayloadAction<IUpdateVoucherReducerState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateVouchersReducerState: actionUpdateVouchersReducerState } = vouchersSlice.actions;

export default vouchersSlice.reducer;
